import { formatPrice } from 'features/carrello/utils';
import styles from './CarrelloFooterSimpleInfoRow.module.scss';

export type CarrelloFooterSimpleInfoRowProps = {
  label: string;
  value: string;
  hasCurrency?: boolean;
  hasBorder?: boolean;
  hasSmallPaddingTop?: boolean;
  hasOnlyHorizontalPadding?: boolean;
  hasValueFormatBase?: boolean;
};

export const CarrelloFooterSimpleInfoRow = ({
  label,
  value,
  hasCurrency,
  hasBorder,
  hasSmallPaddingTop,
  hasOnlyHorizontalPadding,
  hasValueFormatBase,
}: CarrelloFooterSimpleInfoRowProps) => {
  return (
    <p
      className={`${styles.container} ${hasBorder && styles.withBorder} ${hasSmallPaddingTop && styles.smallPadding} ${
        hasOnlyHorizontalPadding ? styles.hasOnlyHorizontalPadding : ''
      }`}
    >
      {/* TODO label */}
      <span className={styles.label}>{label}</span>
      <span className={styles.value}>
        {hasValueFormatBase ? value : formatPrice(value)} {hasCurrency && '€'}
      </span>
    </p>
  );
};
